import { render } from "./airport.vue?vue&type=template&id=1aac615b&scoped=true"
import script from "./airport.vue?vue&type=script&lang=js"
export * from "./airport.vue?vue&type=script&lang=js"

import "./airport.vue?vue&type=style&index=0&id=1aac615b&scoped=true&lang=css"

import exportComponent from "F:\\Vuedemo\\element-便签\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aac615b"]])

export default __exports__